export const getKeyProductFeaturePodCategories = (categoriesConfig) => {
  if (typeof categoriesConfig !== 'string') {
    return [];
  }

  return categoriesConfig
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean);
};

export const hasKeyProductFeaturePodCategoryMatch = (categoriesConfig, navValue) => {
  const categories = getKeyProductFeaturePodCategories(categoriesConfig);
  const safeNavValue = typeof navValue === 'string' ? navValue : '';

  if (!safeNavValue || !categories.length) {
    return false;
  }

  return categories.some((value) => safeNavValue.includes(value));
};

export const getIsSkipKPF = ({
  categoriesConfig,
  navValue,
  isB2B,
  channel,
  experienceType
} = {}) => {
  const showKeyProductFeaturePods = hasKeyProductFeaturePodCategoryMatch(categoriesConfig, navValue);

  if (isB2B) {
    return !showKeyProductFeaturePods;
  }

  if (channel === 'mobile' || experienceType === 'ma') {
    return false;
  }

  return !showKeyProductFeaturePods;
};
